import type { FunctionComponent } from 'react';
import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiPanel,
  EuiText,
  useEuiTheme,
} from '@elastic/eui';
import { css } from '@emotion/react';
import type { Group, Person } from '@domain/person';
import RemoveGroup from './remove-group';

interface GroupPanelProps {
  group: Group;
  person: Person;
}

const GroupPanel: FunctionComponent<GroupPanelProps> = ({ group, person }) => {
  const { euiTheme } = useEuiTheme();

  return (
    <EuiPanel
      paddingSize="s"
      hasShadow={!group.virtual}
      hasBorder={group.virtual}>
      <EuiFlexGroup direction="row" gutterSize="s" responsive={false}>
        <EuiFlexItem>
          <EuiText textAlign="left" size="s">
            <p>
              <span
                css={css`
                  font-weight: bold;
                `}>
                {group.name}
              </span>
              <br />
              <span
                css={css`
                  color: ${euiTheme.colors.subduedText};
                `}>
                {group.description}
              </span>
            </p>
          </EuiText>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <RemoveGroup idnumber={person.idnumber} group={group} />
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiPanel>
  );
};

export default GroupPanel;
